import React from 'react';
import { RiCloseFill } from 'react-icons/ri';

const ModalClose = () => {
    return <RiCloseFill size={24} />;
};

export default ModalClose;
